import React, {Component} from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import Home from "../../components/home";
import { postJobs } from "../../redux/actions";

class HomePage extends Component {
  componentWillMount() {
    const order = {
      field: "createdat",
      sorttype: "desc"
    }
    this.props.loadJobs([], 1, 5, order);
  }

  render() {
    const { translate, jobs, activeFeatures, appSettingsLoaded } = this.props;

    if (appSettingsLoaded && !activeFeatures.some(feature => feature.featureName === 'lrp_free_features')) {
      return <Redirect to="/jobs" />;
    }

    return (
      <Home
        translate={translate}
        jobs={jobs}
      />
    );
  }
}

const mapStateToProps = state => ({
  jobs: state.jobReducer.jobs,
  activeFeatures: state.appSettingReducer.activeFeatures || [],
  appSettingsLoaded: !!state.appSettingReducer.lastResponse,
  ...state
});

const mapDispatchToProps = (dispatch, props) => ({
  loadJobs: (filter, page, count, order) => {
    dispatch(postJobs(filter, page, count, null, order));
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HomePage);
